import { render, staticRenderFns } from "./module-head.vue?vue&type=template&id=347c0a44&scoped=true"
import script from "./module-head.vue?vue&type=script&lang=js"
export * from "./module-head.vue?vue&type=script&lang=js"
import style0 from "./module-head.vue?vue&type=style&index=0&id=347c0a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c0a44",
  null
  
)

export default component.exports